import React from 'react'
import Spreadsheet from 'components/spreadsheet/index'
import { useParams } from 'react-router-dom'
import ErrorBoundary from 'components/error'

const Table: React.FC = () => {
  const { tableId, viewId } = useParams<{ projectId: string; tableId: string; viewId: string }>()
  return (
    <ErrorBoundary>
      <Spreadsheet tableId={tableId ?? ''} tableViewId={viewId ?? ''} />
    </ErrorBoundary>
  )
}

export default Table
